import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  categoryName: string;
  category: string;
  date: string;
  readTime: string;
  views: number;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  categoryName,
  category,
  date,
  readTime,
  views,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-xl border border-background-200 p-5 hover:border-primary-200 transition-all duration-300 group cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="flex items-center gap-2 mb-3">
          <span className="bg-primary-100 text-primary-700 text-[11px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
            {categoryName}
          </span>
        </div>
        <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center gap-4 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views.toLocaleString()}
          </span>
        </div>
      </Link>
    </article>
  );
}